import { render, staticRenderFns } from "./InvoiceNumberForm.vue?vue&type=template&id=4e8c490d&"
import script from "./InvoiceNumberForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceNumberForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports